module.exports = __webpack_public_path__ + "img/project_overview.2c729714.jpg";